import { FILTER_ERROR_MESSAGES } from '../constants/errorMessages.ts';
import { type ConfigurableFilter, FILTER_TYPES } from '../types.ts';

export const validateAndGetOptions = <T>(
  value: unknown,
  typeGuard: (value: unknown) => value is T,
  defaultValue: T,
  filterType: ConfigurableFilter<T>['type']
): T => {
  if (value === undefined) return defaultValue;

  if (!typeGuard(value)) {
    const errorMessage = FILTER_ERROR_MESSAGES[filterType];
    const expectedType = getExpectedTypeForFilter(filterType);
    const receivedType = typeof value;

    throw new Error(`${errorMessage}. Expected type: ${expectedType}. Received type: ${receivedType}`);
  }

  return value;
};

export const getExpectedTypeForFilter = (filterType: string): string => {
  switch (filterType) {
    case FILTER_TYPES.RADIO:
    case FILTER_TYPES.NUMERIC_INPUT:
    case FILTER_TYPES.SWITCH:
    case FILTER_TYPES.TEXT_INPUT:
    case FILTER_TYPES.DROPDOWN:
    case FILTER_TYPES.SEARCH_AND_SELECT:
      return 'string';
    case FILTER_TYPES.CHECKBOX:
    case FILTER_TYPES.AUTOCOMPLETE:
    case FILTER_TYPES.MULTI_OPTION_WITH_RANGE:
    case FILTER_TYPES.MULTI_OPTION_WITH_RADIO:
    case FILTER_TYPES.RANGE_WITH_RADIO:
      return 'string[]';
    case FILTER_TYPES.RANGE:
    case FILTER_TYPES.DATE_RANGE:
      return '[string, string]';
    default:
      return 'unknown';
  }
};
